import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { ShortcutGroup } from 'app/modules/wallforming/components/scenes/toolbar/shortcuts/ShortcutGroup';
import { shortcutList } from 'app/modules/wallforming/components/scenes/toolbar/shortcuts/shortcutList';
import { type ShortcutSection } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutSection';

interface ShortcutsProps {
    section: ShortcutSection;
}

export const Shortcuts = ({ section }: ShortcutsProps) => {
    const { t } = useTranslation();
    const definition = shortcutList[section];

    return (
        <Menu>
            <Menu.Label className="mt-2">{t(definition.labelKey)}</Menu.Label>
            {definition.groups.map((group, groupIndex) => (
                <ShortcutGroup
                    key={group.label ?? groupIndex}
                    definition={definition}
                    group={group}
                    startIndex={definition.groups
                        .slice(0, groupIndex)
                        .reduce((shortcutCount, previousGroup) => shortcutCount + previousGroup.shortcuts.length, 0)}
                />
            ))}
            {definition.notes && (
                <>
                    <Menu.Divider className="mb-2 mt-2" />
                    <div className="text-xs text-text-ultra-light mt-2 ml-1">
                        {definition.notes.map((note) => (
                            <div key={note}>{note}</div>
                        ))}
                    </div>
                </>
            )}
        </Menu>
    );
};
